import styled from 'styled-components';

export const AdminSettings = styled.main`
    min-height: calc(100vh - 64px);
    padding: 10px;
    background: #f4f6f8;
    color: #101828;
    overflow-x: hidden;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    button,
    input,
    select,
    textarea {
        font: inherit;
    }

    button {
        min-height: 30px;
        padding: 6px 12px;
        border: 1px solid #c7d0da;
        border-radius: 3px;
        background: #fff;
        color: #344054;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
    }

    button:hover {
        border-color: #98a2b3;
        background: #f8fafc;
    }

    button:disabled {
        cursor: default;
        opacity: .58;
    }
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    margin: 0 0 6px;
    padding: 8px 10px;
    border: 1px solid #cfd6df;
    border-radius: 0;
    background: #fff;

    span {
        display: none;
    }

    h1 {
        margin: 0;
        color: #101828;
        font-size: 16px;
        line-height: 1.2;
    }

    p {
        display: none;
    }

    @media (max-width: 980px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;

    @media (max-width: 980px) {
        justify-content: flex-start;
    }
`;

export const PrimaryButton = styled.button`
    border-color: #1677d2 !important;
    background: #1677d2 !important;
    color: #fff !important;

    &:hover {
        border-color: #0f66b8 !important;
        background: #0f66b8 !important;
    }
`;

export const DangerButton = styled.button`
    border-color: #f2b8b5 !important;
    background: #fff5f5 !important;
    color: #a2211d !important;

    &:hover {
        border-color: #e58f8b !important;
        background: #ffe9e9 !important;
    }
`;

export const ActivateButton = styled.button`
    border-color: #86c89d !important;
    background: #e6f6ed !important;
    color: #1d6b35 !important;

    &:hover {
        border-color: #56a873 !important;
        background: #d6f0df !important;
    }
`;

export const Summary = styled.section`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    max-width: 100%;
    margin: 0 0 8px;
    padding: 8px;
    border: 1px solid #cfd6df;
    background: #fff;

    div {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        min-height: 34px;
        padding: 6px 12px;
        border: 1px solid #c7d0da;
        border-radius: 4px;
        background: #f8fbff;
    }

    span {
        display: block;
        color: #344054;
        font-size: 12px;
        font-weight: 700;
    }

    strong {
        display: block;
        color: #175cd3;
        font-size: 16px;
        line-height: 1;
    }
`;

export const Message = styled.div<{$type: 'success' | 'error'}>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    margin: 0 0 8px;
    padding: 8px 10px;
    border: 1px solid ${({$type}) => ($type === 'success' ? '#a8d8ba' : '#f1b7b7')};
    border-radius: 3px;
    background: ${({$type}) => ($type === 'success' ? '#eefaf2' : '#fff1f1')};
    color: ${({$type}) => ($type === 'success' ? '#1d6b35' : '#9b1c1c')};
    font-size: 12px;

    button {
        min-width: 30px;
        min-height: 26px;
        padding: 3px 8px;
        border-color: transparent;
        background: transparent;
        color: inherit;
    }
`;

export const TablePanel = styled.section`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0;
    border: 1px solid #cfd6df;
    border-radius: 0;
    background: #fff;
    overflow: hidden;
`;

export const Toolbar = styled.div`
    display: grid;
    grid-template-columns: minmax(220px, 1fr) 180px 150px auto;
    gap: 8px;
    align-items: end;
    min-width: 0;
    padding: 8px;
    border-bottom: 1px solid #d6dde6;
    background: #fff;

    label {
        display: flex;
        flex-direction: column;
        gap: 3px;
        color: #667085;
        font-size: 11px;
        font-weight: 700;
    }

    input,
    select {
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        border: 1px solid #c7d0da;
        border-radius: 3px;
        padding: 0 8px;
        background: #fff;
        color: #101828;
        font-size: 12px;
        font-weight: 500;
    }

    @media (max-width: 980px) {
        grid-template-columns: 1fr;
    }
`;

export const ToolbarMeta = styled.div`
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #667085;
    font-size: 12px;
    font-weight: 700;
`;

export const GridWrap = styled.div`
    height: clamp(300px, 55vh, 560px);
    min-height: 300px;
    width: 100%;
    min-width: 0;

    --ag-font-size: 12px;
    --ag-row-height: 28px;
    --ag-header-height: 28px;
    --ag-list-item-height: 24px;

    .ag-root-wrapper {
        border: 0;
        border-radius: 0;
        font-family: inherit;
    }

    .ag-header {
        background: #0784c3;
    }

    .ag-header-row-column-filter,
    .ag-header-row-column-filter .ag-header-cell,
    .ag-floating-filter,
    .ag-floating-filter-body,
    .ag-floating-filter-button,
    .ag-floating-filter-button-button {
        background: #0784c3 !important;
    }

    .ag-floating-filter-button {
        margin-left: 4px;
        border: 0 !important;
        box-shadow: none !important;
    }

    .ag-floating-filter-button-button {
        width: 16px;
        height: 16px;
        padding: 0;
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
    }

    .ag-floating-filter-button-button,
    .ag-floating-filter-button .ag-icon {
        color: #fff;
    }

    .ag-header-cell-label,
    .ag-header-cell-text {
        color: #fff;
        font-size: 12px;
        font-weight: 700;
    }

    .ag-cell {
        display: flex;
        align-items: center;
        color: #2f328f;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.2;
    }

    .ag-group-value,
    .ag-group-child-count {
        color: #2f328f;
        font-size: 12px;
        font-weight: 400;
    }

    .adminSettingsGridRow_group .ag-cell {
        background: #e9f2fb !important;
        color: #1f3b73;
        font-weight: 700;
        cursor: pointer;
    }

    .adminSettingsGridRow_group .ag-cell-wrapper.ag-row-group {
        align-items: center;
    }

    .adminSettingsGridRow_group .ag-group-value,
    .adminSettingsGridRow_group .ag-group-child-count {
        display: inline-flex;
        align-items: center;
        height: 100%;
        color: #1f3b73;
        font-weight: 700;
        line-height: 1;
    }

    .adminSettingsGridCell_center {
        justify-content: center;
    }

    .ag-floating-filter-body input,
    .ag-input-field-input,
    .ag-text-field-input {
        min-height: 20px;
        color: #101828 !important;
        -webkit-text-fill-color: #101828 !important;
        background: #1689c9 !important;
        border-color: #0f6fa8 !important;
        border-radius: 3px;
    }

    .ag-row {
        border-color: #e1e8f0;
    }

    .ag-row-hover {
        background: #f5faff !important;
    }

    .adminSettingsGridRow_inactive {
        opacity: .62;
    }
`;

export const GridActionButton = styled.button`
    min-height: 24px !important;
    padding: 3px 8px !important;
    font-size: 12px;
`;

export const StatusPill = styled.span<{$kind: 'active' | 'inactive' | 'empty'}>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 22px;
    padding: 2px 8px;
    border-radius: 3px;
    background: ${({$kind}) => {
        if ($kind === 'active') return '#e6f6ed';
        if ($kind === 'inactive') return '#f2f4f7';
        return '#fff4d8';
    }};
    color: ${({$kind}) => {
        if ($kind === 'active') return '#1d6b35';
        if ($kind === 'inactive') return '#667085';
        return '#8a5b00';
    }};
    font-size: 12px;
    font-weight: 700;
`;

export const ModalOverlay = styled.div`
    position: fixed;
    z-index: 1100;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(6, 27, 43, .55);
`;

export const ModalCard = styled.section<{$narrow?: boolean}>`
    width: min(${({$narrow}) => ($narrow ? '560px' : '860px')}, calc(100vw - 40px));
    max-height: calc(100vh - 40px);
    display: flex;
    flex-direction: column;
    border: 1px solid #cfd6df;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 18px 54px rgba(8, 31, 48, .24);
    overflow: hidden;
`;

export const ModalHeader = styled.header`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 16px 12px;
    border-bottom: 1px solid #d6dde6;
    background: #fff;

    h2 {
        margin: 0 0 3px;
        color: #101828;
        font-size: 18px;
        line-height: 1.2;
    }

    p {
        margin: 0;
        color: #667085;
        font-size: 12px;
    }

    > button {
        min-width: 30px;
        min-height: 30px;
        padding: 4px !important;
        border-color: transparent !important;
        background: transparent !important;
        color: #53677d;
        font-size: 18px;
    }
`;

export const ModalTabs = styled.div`
    display: flex;
    gap: 4px;
    padding: 8px 16px 0;
    background: #fff;

    button {
        min-height: 30px;
        border-color: transparent;
        background: transparent;
        color: #53677d;
    }

    button.active {
        border-color: #9dcced;
        background: #eaf5fc;
        color: #0f4775;
    }
`;

export const Form = styled.form`
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    gap: 12px;
    padding: 14px 16px 16px;
    overflow: auto;

    label {
        display: flex;
        flex-direction: column;
        gap: 4px;
        color: #475467;
        font-size: 12px;
        font-weight: 700;
    }

    input,
    select,
    textarea {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #c7d0da;
        border-radius: 3px;
        padding: 7px 8px;
        background: #fff;
        color: #101828;
        font-size: 12px;
        font-weight: 500;
    }

    select[multiple] {
        min-height: 96px;
    }

    textarea {
        min-height: 66px;
        resize: vertical;
    }
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
`;

export const CheckList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding: 9px 10px;
    border: 1px solid #d6dde6;
    border-radius: 3px;
    background: #f8fafc;

    label {
        flex-direction: row;
        align-items: center;
        gap: 8px;
        margin: 0;
        color: #101828;
        font-size: 12px;
    }

    input {
        width: auto;
    }
`;

export const ModuleGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;

    label {
        min-height: 36px;
        flex-direction: row;
        align-items: center;
        gap: 9px;
        padding: 8px 10px;
        border: 1px solid #d6dde6;
        border-radius: 3px;
        background: #f8fafc;
        color: #101828;
    }

    input {
        width: auto;
    }

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
`;

export const EmptyTab = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px 14px;
    border: 1px solid #d6dde6;
    border-radius: 3px;
    background: #f8fafc;

    strong {
        color: #101828;
        font-size: 14px;
    }

    span {
        color: #667085;
        line-height: 1.45;
    }
`;

export const ModalFooter = styled.footer`
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    gap: 10px;
    align-items: center;
    margin-top: auto;
    padding-top: 4px;
`;

export const Denied = styled.section`
    max-width: 720px;
    margin: 64px auto;
    padding: 24px;
    border: 1px solid #d6dde6;
    border-radius: 3px;
    background: #fff;
    text-align: center;
    font-size: 18px;
`;
